export default __webpack_public_path__ + "static/media/ExtraEntries_159x150.09b6113e.png";